function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: (styles["sc-lbxAil"] || "sc-lbxAil") + " " + (styles["gFonQY"] || "gFonQY")
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "32",
  height: "32",
  rx: "7",
  fill: "url(#camtasia-web-icon_svg__a)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#camtasia-web-icon_svg__b)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.85 6.12L7 10h13.43a.4.4 0 00.28-.12l3.17-3.2a.4.4 0 00.1-.43.4.4 0 00-.38-.25H11.13a.4.4 0 00-.28.12zm0 19.76L7 22h13.43a.4.4 0 01.28.12l3.17 3.2a.4.4 0 01.1.43.4.4 0 01-.38.25H11.13a.4.4 0 01-.28-.12"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".74",
  d: "M11 10H7v12h4V10"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "camtasia-web-icon_svg__a",
  x1: "0",
  y1: "0",
  x2: "0",
  y2: "32",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#3D9544"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "camtasia-web-icon_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(7 6)",
  d: "M0 0h17v20H0z"
}))));